import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const PlusIcon = ({ fill="#55b336", disabled, onClick = () => {} }) => (
  <svg
    className={classNames(styles.icon, disabled && styles.disabled)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    onClick={onClick}
  >
    <path 
          d="M10.56,2.56a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm4.762,8.952h-3.81v3.81h-1.9v-3.81H5.8v-1.9h3.81V5.8h1.9v3.81h3.81Z"
          transform="translate(-2.56 -2.56)"
          fill={fill}
          />
  </svg>
);
